const getConfig = () => {
  const host = window.location.host;
  
  if (host.match(/test\.otcmkt\.com/)) {
    return {
      API_BASE_URI: 'https://otcm-backend.test.otcmkt.com/api/v1',
      WEBSITE_URI: 'https://otcm-web.test.otcmkt.com'
    }
  } else if (host.match(/stage\.otcmkt\.com/)) {
    return {
      API_BASE_URI: 'https://otcm-backend.stage.otcmkt.com/api/v1',
      WEBSITE_URI: 'https://otcm-web.stage.otcmkt.com'
    }
  } else if (host.match(/prod\.otcmarkets\.com/)) {
    return {
      API_BASE_URI: 'https://backend.otcmarkets.com/api/v1',
      WEBSITE_URI: 'https://www.otcmarkets.com'
    }
  } else {
    // Use env vars as default
    return {
      API_BASE_URI: process.env.API_BASE_URI || '',
      WEBSITE_URI: process.env.WEBSITE_URI || ''
    }
  }
}

export default getConfig;



// WEBPACK FOOTER //
// ./src/config.js